import { render, staticRenderFns } from "./project-tab-documents-photos.vue?vue&type=template&id=9184f10a"
import script from "./project-tab-documents-photos.vue?vue&type=script&lang=js"
export * from "./project-tab-documents-photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports